<template>
  <div style="position: relative">
    <div
      class="tab"
      :style="{
        height: 'calc(0.44rem + ' + $store.state.statusBarHeight + 'px)',
        paddingTop: $store.state.statusBarHeight + 'px',
        background: background
      }"
    >
      <div class="tab_menu">
        <div class="tab_back" :class="[$store.state.isMirroring && 'mirror']" @click="goBack">
          <img v-if="showBack" class="tab_back_img" src="@/assets/back_new.png" alt="back" />
        </div>
        <span
          class="tab_title"
          :style="{
            color: color
          }"
        >
          {{ title }}
        </span>
        <span v-if="rightInfo" class="tab_right_info" :class="[$store.state.isMirroring && 'mirror']">
          {{ rightInfo }}
        </span>
        <span v-else class="tab_right_info" :class="[$store.state.isMirroring && 'mirror']">
          <slot></slot>
        </span>
      </div>
    </div>
    <div class="tab_space"></div>
  </div>
</template>

<script>
export default {
  name: 'Tabbar',
  data() {
    return {}
  },
  props: {
    title: [String],
    rightInfo: [String],
    back: Function,
    background: {
      type: String,
      default: '#fff'
    },
    color: {
      type: String,
      default: '#2f2f2f'
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goBack() {
      if (this.back) {
        this.back()
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  user-select: none;
}

.tab {
  width: 100%;
  height: 0.44rem;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 2000;
}

.tab_menu {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.44rem;
  flex-wrap: nowrap;
  position: relative;
}

.tab_back {
  display: flex;
  height: 0.44rem;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0.16rem;
}

.tab_back.mirror {
  left: auto;
  right: 0.16rem;
  transform: rotate(180deg);
}

.tab_back_img {
  width: 0.16rem;
  height: 0.16rem;
  display: block;
}

.tab_title {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-weight: 600;
  width: 100%;
  text-align: center;
}

.tab_right_info {
  position: absolute;
  top: 0;
  right: 0.16rem;
  color: #282828;
  height: 0.44rem;
  font-size: 0.16rem;
  display: flex;
  align-items: center;
}

.tab_right_info.mirror {
  right: auto;
  left: 0.16rem;
}

.tab_space {
  height: 0.44rem;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue